import React from 'react'
import Link from 'next/link'

import { css } from 'styled-components'
import variables from '../../shared/styles/variables'
// import { minMq } from '../../shared/styles/breakPoints'
// import variables from '../../shared/styles/variables'

const backBtn = css`
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;

  a > span {
    color: ${variables.THEME_C};
    font-weight: 500;

    &::before {
      content: '<';
      margin-right: 5px;
    }
  }
`

interface OwnProps {
  href: string
}

type Props = OwnProps

const BackBtn: React.FC<Props> = (props) => {
  return (
    <div css={backBtn}>
      <Link href={props.href}>
        <span>目次に戻る</span>
      </Link>
    </div>
  )
}

export default BackBtn
